import { LANGUAGE_KEY } from './message.constants';

const en: Record<LANGUAGE_KEY, string> = {
  [LANGUAGE_KEY.TEST]: 'TEST',
};

export default en;
